import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = ({ cambiarIdioma, idioma }) => {
  const { t } = useTranslation();
  

  const manejarCambioIdioma = (event) => {
    cambiarIdioma(event.target.value, "yes");
  };

   
  
    if (idioma) {
      return (
        <select onChange={manejarCambioIdioma} className="custom-navbar-item custom-select-language"
        value = {idioma}>
          <option value="en">{t('Inglés')}</option>
          <option value="es">{t('Español')}</option>
          <option value="fra">{t('Francés')}</option>
          <option value="deutsch">{t('Alemán')}</option>
          <option value="ita">{t('Italiano')}</option>
          <option value="neer">{t('neerlandés')}</option>
          <option value="por">{t('portugués')}</option>
        </select>
      );
     
    } else {
      return (
        <select onChange={manejarCambioIdioma} className="custom-navbar-item custom-select-language"
        value = "es">
          <option value="en">{t('Inglés')}</option>
          <option value="es">{t('Español')}</option>
          <option value="fra">{t('Francés')}</option>
          <option value="deutsch">{t('Alemán')}</option>
          <option value="ita">{t('Italiano')}</option>
          <option value="neer">{t('neerlandés')}</option>
          <option value="por">{t('portugués')}</option>
        </select>
      );
    }

 
};

export default LanguageSelector;
